import React from "react";
import { Nav, Navbar} from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../images/logo.svg";
import styled from "styled-components";

const Styles = styled.div`
  a, .navbar-brand, .navbar-nav .nav-link {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;

      display: flex;
      align-items: center;

      text-decoration: none;
      color: #45505A;
      &:hover {
          color: #2196F3;
      }
      flex: none;
      margin-right:1.7%;
  }
`

export default function NotAuthorizedNavbar() {
  return (
    <Styles>
      <Navbar collapseOnSelect expand="sm" bg="white" variant="white">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Brand>
          <Link to="/"> 
            <img src={logo} height="74px" width="115px" className="logo" alt=""/> 
          </Link>
        </Navbar.Brand>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/vacancies"> Вакансии </Nav.Link>
            <Nav.Link href="/candidates"> Кандидаты </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <Nav className="me-auto"/>
        <Nav.Link><Link to="/"> Войти в аккаунт </Link></Nav.Link>
      </Navbar>
    </Styles>
  )
}